'use client'

import * as stylex from '@stylexjs/stylex'
import type { ComponentPropsWithRef } from 'react'

import { fieldStyles } from '../field'
import type { FieldValueProps } from '../field'
import { breakpoints, controlSizes, fontSizes, spacing } from '../tokens/tokens.stylex'

const styles = stylex.create({
  compact: {
    height: { default: controlSizes.compact, [breakpoints.coarse]: controlSizes.touch },
    fontSize: fontSizes.small,
    paddingInline: spacing.space8,
  },
})

type NativeInputProps = ComponentPropsWithRef<'input'>
type InputOptions = { size?: 'md' | 'sm' }

export type InputProps = Omit<
  NativeInputProps,
  'className' | 'style' | 'size' | 'value' | 'defaultValue' | 'onChange' | 'readOnly'
> &
  FieldValueProps<NativeInputProps> &
  InputOptions

/**
 * Edit one line with native input semantics; use Textarea for multiple lines. Applications supply labels,
 * descriptions, validation messages, and submitted values.
 *
 * Status: supported.
 */
export function Input({ size = 'md', ...props }: InputProps) {
  return <input {...props} {...stylex.props(fieldStyles.control, fieldStyles.input, size === 'sm' && styles.compact)} />
}
